import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { PublicationEditComponent } from 'src/app/care/publications/publication-edit/publication-edit.component';


downgradedAngularModule
  .directive('angularPublicationEdit', downgradeComponent({ component: PublicationEditComponent }));